import { StyleSheet } from 'aphrodite'

import main from './main'
import form from './form'
import box from './box'

export default {
  main: StyleSheet.create(main),
  form: StyleSheet.create(form),
  box: StyleSheet.create(box)
}



// WEBPACK FOOTER //
// ./src/components/Register/style/index.js